import type { ElementType, FC, ReactNode } from 'react';

interface SectionHeaderProps {
  icon: ElementType<{ className?: string }>;
  title: string;
  subtitle?: string;
  /** Replaces the `subtitle` text with custom content (e.g. a loading row). */
  subtitleSlot?: ReactNode;
  /** Right-aligned actions (e.g. a Clear button). */
  actions?: ReactNode;
}

export const SectionHeader: FC<SectionHeaderProps> = ({
  icon: Icon,
  title,
  subtitle,
  subtitleSlot,
  actions,
}) => (
  <div className="flex shrink-0 items-center gap-2.5 border-b border-border/60 bg-muted/20 px-4 py-2.5">
    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-primary/10 text-primary">
      <Icon className="h-4 w-4" />
    </span>
    <div className="min-w-0 flex-1">
      <h3 className="truncate text-sm font-semibold text-foreground">{title}</h3>
      {subtitleSlot ??
        (subtitle ? (
          <p className="truncate text-xs text-muted-foreground">{subtitle}</p>
        ) : null)}
    </div>
    {actions ? <div className="shrink-0">{actions}</div> : null}
  </div>
);

export default SectionHeader;
